// entry.js - ES module entry point for app code
import { initCursor } from './modules/cursor.js';
import { initTheme } from './modules/theme.js';
import { initSlidersAndScroll } from './modules/sliders.js';
import './menu-app.js'; // menu-app is still a script but we'll include it in the bundle too

function init() {
    try { initTheme(); } catch (e) { console.warn('theme init failed', e); }
    try { initCursor(); } catch (e) { console.warn('cursor init failed', e); }
    try { initSlidersAndScroll(); } catch (e) { console.warn('sliders init failed', e); }
}

// Auto-initialize on DOMContentLoaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(init, 0);
} else {
    document.addEventListener('DOMContentLoaded', init);
}

export default init;

// Hide preloader when app initializes and show runtime errors on-page
function hidePreloader() {
    try {
        const pre = document.getElementById('preloader');
        if (pre) pre.style.display = 'none';
    } catch (err) {
        console.warn('hidePreloader failed', err);
    }
}

// Create a simple error overlay so errors are visible to QA without opening devtools
function createErrorOverlay() {
    if (document.getElementById('app-error-overlay')) return;
    const overlay = document.createElement('div');
    overlay.id = 'app-error-overlay';
    overlay.style.position = 'fixed';
    overlay.style.left = '12px';
    overlay.style.right = '12px';
    overlay.style.bottom = '12px';
    overlay.style.padding = '12px 16px';
    overlay.style.background = 'rgba(220,20,60,0.95)';
    overlay.style.color = 'white';
    overlay.style.fontFamily = 'monospace';
    overlay.style.fontSize = '13px';
    overlay.style.zIndex = '99999';
    overlay.style.borderRadius = '6px';
    overlay.style.maxHeight = '40vh';
    overlay.style.overflow = 'auto';
    overlay.style.boxShadow = '0 6px 18px rgba(0,0,0,0.4)';
    overlay.style.display = 'none';
    document.body.appendChild(overlay);
    return overlay;
}

function showErrorOverlay(message) {
    try {
        const overlay = createErrorOverlay();
        if (!overlay) return;
        overlay.style.display = 'block';
        const time = new Date().toLocaleTimeString();
        const msg = document.createElement('div');
        msg.style.marginBottom = '8px';
        msg.textContent = `[${time}] ${message}`;
        overlay.appendChild(msg);
    } catch (err) {
        console.warn('showErrorOverlay failed', err);
    }
}

// Global error handlers
window.addEventListener('error', function (ev) {
    try {
        const msg = ev && ev.error && ev.error.stack ? ev.error.stack : (ev && ev.message) || String(ev);
        console.error('Runtime error captured', msg);
        showErrorOverlay(msg);
        hidePreloader();
    } catch (e) {
        // ignore
    }
});

window.addEventListener('unhandledrejection', function (ev) {
    try {
        const reason = ev && ev.reason ? (ev.reason.stack || ev.reason) : ev;
        console.error('Unhandled rejection', reason);
        showErrorOverlay('Unhandled rejection: ' + (reason && reason.toString ? reason.toString() : String(reason)));
        hidePreloader();
    } catch (e) {
        // ignore
    }
});

// Hide preloader shortly after successful init
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(hidePreloader, 50);
} else {
    document.addEventListener('DOMContentLoaded', function () {
        setTimeout(hidePreloader, 50);
    });
}

// Forward console errors and warnings into the on-page overlay to help QA
(function forwardConsoleToOverlay() {
    ['error', 'warn'].forEach((level) => {
        const orig = console[level];
        console[level] = function (...args) {
            try {
                const text = args.map(a => {
                    try { return typeof a === 'object' ? JSON.stringify(a) : String(a); } catch (e) { return String(a); }
                }).join(' ');
                showErrorOverlay(`[console.${level}] ${text}`);
                hidePreloader();
            } catch (e) {
                // ignore
            }
            orig && orig.apply && orig.apply(console, args);
        };
    });
})();
